import * as React from 'react';
import { logout } from '../../api/authClientApi';
import { PublicPageProvider } from '../_contexts/PublicPageContext';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { getMaybeActiveEmployeeOrLogin } from '../../api/serverApiHelpers';
import { Redirect } from 'react-router-dom';
import { applicationEndpoints } from '../../amorg-common/applicationEndpoints';

export function PortalLogoutPage(): JSX.Element
{
    return (
        <PublicPageProvider>
            <PortalLogoutPageContent />
        </PublicPageProvider>
    );
}

function PortalLogoutPageContent(): JSX.Element 
{
    const [loading, setLoading] = React.useState(true);
    const [siteId, setSiteId] = React.useState('');

    React.useEffect(() => {
        async function run() {
            const user = await getMaybeActiveEmployeeOrLogin();
            if(user)
            {
                setSiteId(user.siteId);
            }
            await logout();
            setLoading(false);
        }
        run();
    },[]);

    console.log('siteId', siteId);

    return (
        <PublicPageProvider>
                
            <LoadingPageOverlay loading={loading} />

            {!loading &&
                <>
                    {siteId 
                        ?
                        <Redirect to={applicationEndpoints.portal_login_siteId.replace(':siteId', siteId)} />
                        :
                        <Redirect to={applicationEndpoints.portal_login} />
                    }
                </>
            }
                
        </PublicPageProvider>
    );
}